import React from 'react'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'
import HelpHeader from './HelpHeader'
import HelpSearch from './HelpSearch'
import HelpCategories from './HelpCategories'
import HelpFAQ from './HelpFAQ'
import HelpContact from './HelpContact'

function HelpCenter() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <HelpHeader />
         <HelpSearch />
         <HelpCategories />
         <HelpFAQ />
         <HelpContact />

         <Footer
            logo={"/Logo NextMaker.png"}
            bgColor="bg-dark-1"
            textColor="text-gray-100"
            borderColor="border-gray-400/20"
         />
      </div>
   )
}

export default HelpCenter